import { Component, HostBinding, OnInit } from '@angular/core';
import { ToastService } from './_services';
import { TeamsAuthService } from './_services/teams-auth.service';
import { Router, NavigationError, NavigationEnd } from '@angular/router';
import Swal from 'sweetalert2';
import { filter, take } from 'rxjs/operators';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  @HostBinding('class') class = 'flex flex-col bg-defaultBackground';
  public swal: typeof Swal;

  constructor(
    private toastService: ToastService,
    private router: Router,
    private matIconRegistry: MatIconRegistry,
    private teamsAuthService: TeamsAuthService
  ) {
    matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    matIconRegistry.addSvgIconSet('material-symbols-outlined');
    this.swal = Swal.mixin({
      toast: true,
      position: 'bottom-start',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      showCloseButton: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    this.router.events.pipe(filter((event) => event instanceof NavigationError)).subscribe((event: NavigationError) => {
      if (event.error instanceof Error && event.error.name === 'ChunkLoadError') {
        console.warn('Reloading due to load chunk file error');
        window.location.assign(event.url || '/');
      }
    });

    // Dismiss the native Microsoft Teams loading indicator once the first page has rendered
    // (no-op when not running inside Teams). Required for Teams store certification (policy 1140.4.1.21).
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        this.teamsAuthService.notifyContentReady();
      });
  }
  /*
    panelClass = slick-custom-snackbar-success
    panelClass = slick-custom-snackbar-error
    panelClass = slick-custom-snackbar-warning
   */
  ngOnInit(): void {
    // Detect whether we're embedded in a Microsoft host (Teams/Outlook/M365) so the mobile
    // bottom navigation rail can be dropped in favour of the hamburger menu (Teams review #34).
    this.teamsAuthService.detectMicrosoftHost();

    this.toastService.queue.subscribe((value) => {
      switch (value.panelClass) {
        case 'slick-custom-snackbar-error':
          value.panelClass = 'error';
          break;
        case 'slick-custom-snackbar-warning':
          value.panelClass = 'warning';
          break;
        default:
          value.panelClass = 'success';
          break;
      }
      this.swal.fire(value.message, '', value.panelClass || 'success');
    });
  }
}
